import { PageQueryParams } from '../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { UseConsultationsResponse } from './useConsultations.types';

const PREFIX = '[consultationsQuery]';

export const queryConsultations = async (params: PageQueryParams) => {
  console.log(PREFIX, `Fetching consultations...`);
  const response = await CONSULTATIONS_ENDPOINTS.allConsultations(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received consultations.`);
  return json as UseConsultationsResponse;
};
